// TODO: Proper conditional formatting
export default value => {
  const classList = [];
  if (value && value.trim().startsWith('-')) {
    classList.push('negative');
  }

  return { value, classList };
};
